import React from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent,
  Avatar,
  Chip,
  Stack,
  Divider,
} from '@mui/material';
import {
  SearchOff,
  Add,
  Info,
} from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { DESIGN_TOKENS } from '../../../design-system/tokens/colors';

export interface AnimalNotFoundData {
  data?: {
    status?: string;
    campos_obrigatorios?: string;
    operation_code?: string;
    operation_status?: string;
    message?: string;
  };
  content_type?: string;
  status?: string;
  resumo?: string;
  url?: string;
}

export interface AnimalNotFoundViewProps {
  animalNotFoundData: AnimalNotFoundData;
}

const getRequiredFields = (campos?: string): string[] => {
  if (!campos) return [];
  return campos.split(',').map(field => field.trim());
};

const getFieldLabel = (field: string, t: any): string => {
  const fieldLabels: { [key: string]: string } = {
    name: t('farm:animal.fields.name'),
    breed_code: t('farm:animal.fields.breed_code'),
    gender: t('farm:animal.fields.gender'),
    birth_date: t('farm:animal.fields.birth_date'),
    weight: t('farm:animal.fields.weight'),
    paddock: t('farm:animal.fields.paddock'),
  };
  
  return fieldLabels[field] || field;
};

export const AnimalNotFoundView: React.FC<AnimalNotFoundViewProps> = ({
  animalNotFoundData,
}) => {
  const { t } = useTranslation(['farm', 'common']);
  const {
    data,
    status,
    resumo,
  } = animalNotFoundData;

  const requiredFields = getRequiredFields(data?.campos_obrigatorios);

  return (
    <Box sx={{ 
      p: 4, 
      maxWidth: 400, 
      mx: 'auto',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '300px',
      textAlign: 'center'
    }}>
      <Avatar
        sx={{
          width: 80,
          height: 80,
          bgcolor: DESIGN_TOKENS.colors.status.warning[100],
          mb: 3,
        }}
      >
        <SearchOff 
          sx={{ 
            fontSize: '2.5rem', 
            color: DESIGN_TOKENS.colors.status.warning[600] 
          }} 
        />
      </Avatar>
      
      <Typography
        variant="h5"
        sx={{
          fontWeight: 600,
          color: DESIGN_TOKENS.colors.text.primary,
          mb: 2,
        }}
      >
        {t('farm:animal.notFound')}
      </Typography>
      
      <Typography
        variant="body1"
        sx={{
          color: DESIGN_TOKENS.colors.text.secondary,
          lineHeight: 1.6,
        }}
      >
        {t('farm:animal.registrationInstruction')}
      </Typography>
    </Box>
  );
};

export default AnimalNotFoundView;